import type { RouteLocationNormalized } from "vue-router";

/**
 * Whether a navigation changes the PAGE, which is when the route progress bar
 * shows. Two navigations do not:
 *
 * - the initial load (`from.name` is unset), which has its own loader;
 * - a query-only change on the same path -- the request list writing its
 *   search and filters, the composer recording `?draft=`. The layout keys the
 *   routed view on `route.path` (`layout/Layout.vue`), so nothing remounts and
 *   there is nothing to wait for; showing the bar there is a one-frame flicker.
 */
export function isPageChange(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): boolean {
  return Boolean(from.name) && to.path !== from.path;
}
